<div class="slider-container">
    <div #sliderTrack class="slider-track">

        <!-- <div class="slider-tick" *ngFor="let pos of normalizedPositions; let i = index" [style.left.%]="pos * 100">
            <span class="slider-label">{{ stopPoints[i] }}</span>
        </div> -->

        <div #sliderThumb class="slider-thumb" [class.active]="isDragging"
            (mousedown)="!isSliderDisabled && startDrag($event)">
        </div>
    </div>
</div>